import { AxiosResponse } from 'axios';
import Api from '../api';
import { ModuleType } from '../modules.types';

const DeleteForEverApi = ({
  moduleType,
  id,
}: {
  moduleType: ModuleType;
  id: number;
}): Promise<AxiosResponse> => {
  const path = `/admin/${moduleType}/delete/${id}`;
  return Api.getInstance().request.delete(path);
};
export default DeleteForEverApi;
